const Selectstyles = (fieldErr: any) => ({
  control: (baseStyles: any, state: any) => ({
    ...baseStyles,
    backgroundColor: 'white',
    borderStyle: 'hidden',
    border: state.menuIsOpen ? '1px solid #498BC9' : '1px solid #DBDADE',
    boxShadow: state.isFocused ? 0 : 0,
    borderTopRightRadius: '6px',
    borderTopLeftRadius: '6px',
    borderBottomRightRadius: state.menuIsOpen ? '0px' : '6px',
    borderBottomLeftRadius: state.menuIsOpen ? '0px' : '6px',
    color: '#dddddd',
    fontSize: '14px',
    fontWeight: '400',
    height: '40px',
    '&:hover': {
      border: state.menuIsOpen ? '1px solid #498BC9' : '1px solid #DBDADE',
    },
    outline: fieldErr ? '1px solid red' : 'transparent',
  }),
  menu: (base: any) => ({ ...base, marginTop: '0px' }),
  menuList: (base: any) => ({
    ...base,
    borderTopRightRadius: '0px',
    borderTopLeftRadius: '0px',
    borderBottomRightRadius: '6px',
    borderBottomLeftRadius: '6px',
    padding: '0',
  }),
  container: (base: any) => ({ ...base, border: 0 }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#ddd' : 'white',
    fontSize: '14px',
    color: state.isSelected ? '#333' : '#000',
    '&:hover': {
      backgroundColor: '#498BC9',
      color: 'white',
    },
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    display: 'none',
  }),
  valueContainer: (base: any, state: any) => ({
    ...base,
    padding: '0 15px',
    border: '0',
    marginTop: '-5px',
    color: state.selected ? 'black' : '#dddddd',
  }),
  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    color: 'black',
    fontSize: '12px',
    marginTop: '-4px',
    transform: state.selectProps.menuIsOpen ? 'rotate(-180deg)' : 'rotate(0)',
    transition: '250ms',
  }),
  singleValue: (base: any) => ({
    ...base,
    margin: '0',
    padding: '0',
    top: '45%',
  }),
  placeholder: (base: any) => ({
    ...base,
    color: '#6c757d',
    fontWeight: '400',
    margin: '0',
  }),
})

export default Selectstyles
